// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payer-tab{
    background-color: #F4F7FE;
    height: 100vh;
}

.payer-header{
    padding-top: 20px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid grey;
}

.payer-header>button{
    font-size: 12px;
}

.payer-input{
    width: 400px;
    border-radius: 20px;
    background-color: #FFFFFF;
    border: none;
    padding-left: 10px;
    height: 40px;
}

.payer-checkbox{
    margin-left:20px !important;
    
}

.payer-table-head{
    display: grid;
    grid-template-columns: repeat(10, minmax(0, 1fr));
    text-align: center;
    /* border-bottom: 1px solid #a3aed0; */
    /* margin-top:20px; */
    padding-bottom: 10px;
    color: #1B2559;
    font-weight: 600;
    background: rgba(244, 247, 254, 0.2);
    border-color: transparent;
    transition-delay: 0s,0s,0s,0s;
    transition-duration: 0.25s,0.25s,0.25s,0s;
    transition-timing-function: linear,linear,linear,linear;
    filter: none;
    -webkit-backdrop-filter: blur(100px);
            backdrop-filter: blur(100px);
    /* background-color: #a3aed0; */
    margin-top: 10px;
    align-items: center;
    font-size: 16px;
    margin: 15px;
    position: sticky;
    top: 0;
    z-index: 1;
}

.payer-table-body{
    display: grid;
    grid-template-columns: repeat(10, minmax(0, 1fr));
    /* border-bottom: 1px solid #a3aed0; */
    /* margin-top:20px; */
    padding-bottom: 10px;
    color: gray;
   background-color: #FFFFFF;
    border-color: transparent;
    transition-delay: 0s,0s,0s,0s;
    transition-duration: 0.25s,0.25s,0.25s,0s;
    transition-timing-function: linear,linear,linear,linear;
    filter: none;

    /* background-color: #a3aed0; */
    margin-top: 10px;
    align-items: center;
    margin: 15px;
    padding: 15px 10px;
    border-radius: 20px;
    text-align: center;
    font-size: 12px;

}

.payer-table-body:hover{
  transform: scale(1.01);
}
.payer-table-head>div:nth-child(6){
    grid-column: span 3;
    /* text-align: center; */
 }

 .payer-table-body>div:nth-child(6){
    grid-column: span 3;
    text-align: center;
 }

.payer-table{
    margin-top: 30px;
    height: 77vh;
    overflow-y: scroll;
    text-align: center;
}

.payer-table-body


.firstreadmoreIcon{
    display: none !important;
}

.payer-table-body:hover .firstreadmoreIcon{
    display: block !important;
}

.payer-table-body:hover .readmoreIcon{
    display: none !important;
}



.payer-main-header{
     /* background-color: #FFFFFF; */
     margin-right: 20px;
     display: flex;
     justify-content: space-between;
     color: #1B2559;
     /* padding-bottom: 20px; */
     /* padding-top: 20px; */
}

.payer-content-div{
    display: flex;
    margin-top: 30px;
}
.payer-content-div>div:nth-child(1){
   width: 65%;  
   background-color: #FFFFFF;
   margin-right: 20px;
   height: calc(100vh - 18vh);
   margin-left: 20px;
   border-radius: 30px; 
}

.payer-content-div>div:nth-child(2){
    width: 35%;   
    background-color: #FFFFFF;
    margin-right: 20px;
    /* height: calc(100vh - 1vh); */
    border-radius: 30px;
 }

 .other-info{
     text-align: center;
     padding-top: 10px;
 }

 .other-info .head{
     font-weight: bold;
     font-size: 20px;
     padding: 10px;
     margin: 0px 50px;
     border-bottom: 1px solid grey;
 }


 .other-info .overall-due{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    /* background-color: #F4F7FE; */
    margin: 10px;
    padding: 10px;
    border-radius: 15px;
 }

 .payer-invoice-head{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    text-align: center;
    /* border: 1px solid grey; */
    background-color: #1F2B8F;
    border-radius: 20px;
    padding: 10px ;
    color: #FFFFFF;
    position: sticky;
    top: 0;
    z-index: 1;
 }

 .payer-contact-head{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    text-align: center;
        /* border: 1px solid grey; */
        background-color: #1F2B8F;
        border-radius: 20px;
        padding: 10px ;
        color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 1;
 }


 .payer-invoice-table{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    text-align: center;
    /* border: 1px solid grey; */
    margin: 10px 5px;
    background-color: #FFFFFF;
    border-radius: 20px;
    padding: 10px ;
    font-size: 12px;
   
 }

 .payer-contact-table{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    text-align: center;
    margin: 10px 5px;
    background-color: #FFFFFF;
    border-radius: 20px;
    padding: 10px ;
 }

 .payer-invoice{
    margin: 10px;
    padding: 10px;
    background-color: #F4F7FE;
    border-radius: 20px;
    height: 30vh;
    /* overflow-y: scroll; */
    /* box-shadow: 0px 0px 5px lightblue; */

 }

 .payer-table{
   overflow-y: scroll;
   height:80%;
 }


 .payer-table::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .payer-table::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

  .payer-invoice>div:nth-child(1){
     font-weight: bold;
     color: #1B2559;
  }

  .chat-body{
    padding: 20px;
  }

  .contact-name{
  
     padding: 10px;
     border-radius: 15px;
     display: flex;
     justify-content: end;
  }


  .contact-info{
     margin-top: 10px;
     display: flex;
     justify-content: space-between;
     padding: 10px;
     /* border: 0.2px solid lightgray; */
     background-color: #F4F7FE;
     border-radius: 15px;
  }

  .chat-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* margin-top: 10px; */
    padding: 10px;
    /* background-color: #F4F7FE; */
    box-shadow: 0px 0px 5px lightgray;
    border-radius: 20px 20px 0px 0px;
  }


  .chat-info button{
    color: #FFFFFF;
    background-color: #1F2B8F;
    padding: 5px 10px;
    border: none;
    font-size: 13px;
    border-radius: 5px;
  }


  .payer-chat{
    width: 100%;
    height: 70vh;
    border: 1px solid lightgray;
    border-radius: 20px;
    overflow: scroll;
    margin-top: 10px;
    /* background-color: #F4F7FE; */
  }

  .chat-main{
    /* height: 85%; */
    height: calc( 100% - 140px);
  }

  .chat-bottom{
    /* align-self: flex-end; */
    padding: 20px 20px 20px 20px;
     border-radius: 0px 0px 20px 20px;
     box-shadow: 0px 0px 5px white;
     display: flex;
     justify-content: space-between;
     background-color:#F4F7FE;
     align-items: center;
   
  }

  .input-payer{
    width: 70%;
    border: none;
    background-color: #FFFFFF ;
    border-radius: 20px;
    /* box-shadow: 0px 0px 5px lightgray; */
    height: 30px;
    padding-left: 20px;
    
  }

  .chat-main {
    /* max-width: 600px; */
    margin: auto;
    overflow-y:auto ;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }

  .message {
    max-width: 70%;
    margin: 10px;
    /* padding: 15px; */
    border-radius: 10px;
    clear: both;
  }

  .message.left {
    float: left;
    /* display: block; */
  }

  .message.left>div:nth-child(1){
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }



  .message.left>div:nth-child(1)>div>div{
    font-size: 12px;
  }

  .message.left>div:nth-child(1)>div>div:nth-child(1){
    margin-left: 5px;
    color: cadetblue;
    
  }

  .message.left>div:nth-child(1)>div>div:nth-child(2) span{
    margin-left: 5px;
    color:#4B5563;
  }

  .message.right>div:nth-child(1)>div>div{
    font-size: 12px;
  }

  .time-zone{
    font-size: 12px;
    margin: 0px 5px;
    padding: 0px 5px
  }

  .message.right>div:nth-child(1)>div>div:nth-child(1){
    /* margin-left: 5px; */
    color: lightslategray;
    
  }


  .message.left>div:nth-child(4){
    float: right;
    font-size: 12px;
    color: lightslategray;
  }

  .message.right>div:nth-child(4){
    float: left;
    font-size: 12px;
    color:lightslategray;
  }

  .message.right>div:nth-child(1)>div>div:nth-child(2) span{
    margin-left: 5px;
    color:#FBD5D5;
  }

  .message.left>div:nth-child(3){
    background-color: #e6e6e6;
    padding: 10px;
    border-radius: 10px;
  }

  .message.left>div:nth-child(2) {
    /* float: right; */
    font-size: 10px;
    margin:  2px 0px 6px 0px;
    text-align: start;
    /* display: block; */

  }

  .message.right {
    float: right;
    /* display: block; */

  }

  .message.right>div:nth-child(2) {
    /* float: right; */
    font-size: 10px;
    margin:  2px 0px 6px 0px;
    text-align: end;
    /* display: block; */

  }

  .message.right>div:nth-child(3){
    background-color:turquoise;
    color: #FFFFFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: end;
  }

  .message.right>div:nth-child(1){
    padding-bottom: 10px;
    display: flex;
    justify-content: end;
    flex-direction: row-reverse;
  }

  .date-header{
    font-weight: bold;
    display: block;
    display: flex;
    justify-content: center;
     margin-top: 10px;
     flex-direction: column;
  }

  .date-header hr{
    width: 100%;
    border-bottom: 1px solid #ccc; 

  }

  .date-header>div{
    /* background-color: #F4F7FE; */
    width: 100px;
    text-align: center;
    padding: 5px 10px;
    border-radius: 5px ;
    color:#1B2559;
  }

  .menu_input textarea{
    border-radius: 20px;
    border:  none !important;
    background-color: #FFFFFF !important;
    width: 100% !important;
  }


  .send-users{
    display: flex;
  }

  .send-users>div{
    padding: 0px 2px;
  }


  .load-more{
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  .chat-drop-down{
    width: 150px;
    margin: 0px 20px;
  }


  .payer-checkbox1 span{
     font-size:12px !important;
  }



  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    /* height: 100vh; */
    cursor: pointer;
  }
  
  .loader {
    width: 20px;
    height: 20px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .rotate {
    animation-play-state: running;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  

  .upload-div{
    position: absolute;
    margin-top: -100px;
    z-index: 99;
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 0px 2px grey;
    display: none;
  }

  .upload-div li{
    padding: 5px 10px;
  }

  .upload-icon:hover .upload-div{
    display: block;
  }

  .upload-main{
    cursor: pointer;
  }

  .upload-main:hover .upload-div{
    display: block;
  }`, "",{"version":3,"sources":["webpack://./src/components/Collection/Payer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,sCAAsC;IACtC,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;IACZ,oCAA4B;YAA5B,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iDAAiD;IAEjD,sCAAsC;IACtC,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;GACZ,yBAAyB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;;IAEZ,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IAEnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;EACE,sBAAsB;AACxB;AACA;IACI,mBAAmB;IACnB,wBAAwB;CAC3B;;CAEA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;;AAED;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;IAII,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;;;AAIA;KACK,+BAA+B;KAC/B,kBAAkB;KAClB,aAAa;KACb,8BAA8B;KAC9B,cAAc;KACd,0BAA0B;KAC1B,uBAAuB;AAC5B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;GACG,UAAU;GACV,yBAAyB;GACzB,kBAAkB;GAClB,0BAA0B;GAC1B,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;CACtB;;CAEA;KACI,kBAAkB;KAClB,iBAAiB;CACrB;;CAEA;KACI,iBAAiB;KACjB,eAAe;KACf,aAAa;KACb,gBAAgB;KAChB,6BAA6B;CACjC;;;CAGA;IACG,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,mBAAmB;CACtB;;CAEA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,UAAU;CACb;;CAEA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;QACd,4BAA4B;QAC5B,yBAAyB;QACzB,mBAAmB;QACnB,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,MAAM;QACN,UAAU;CACjB;;;CAGA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;;CAElB;;CAEA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;CACjB;;CAEA;IACG,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,uCAAuC;;CAE1C;;CAEA;GACE,kBAAkB;GAClB,UAAU;CACZ;;;CAGA;IACG,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;EAEA;KACG,iBAAiB;KACjB,cAAc;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;KAEG,aAAa;KACb,mBAAmB;KACnB,aAAa;KACb,oBAAoB;EACvB;;;EAGA;KACG,gBAAgB;KAChB,aAAa;KACb,8BAA8B;KAC9B,aAAa;KACb,mCAAmC;KACnC,yBAAyB;KACzB,mBAAmB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,+BAA+B;IAC/B,iCAAiC;IACjC,gCAAgC;EAClC;;;EAGA;IACE,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;KAC3B,gCAAgC;KAChC,6BAA6B;KAC7B,aAAa;KACb,8BAA8B;KAC9B,wBAAwB;KACxB,mBAAmB;;EAEtB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;;EAEpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,mBAAmB;EACrB;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;;EAElB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf;EACF;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;;EAEvB;;;EAGA;IACE,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;;EAEtB;;EAEA;IACE,YAAY;IACZ,oBAAoB;;EAEtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,oBAAoB;;EAEtB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,uBAAuB;KACtB,gBAAgB;KAChB,sBAAsB;EACzB;;EAEA;IACE,WAAW;IACX,6BAA6B;;EAE/B;;EAEA;IACE,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;EACxB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;;EAGA;KACG,yBAAyB;EAC5B;;;;EAIA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".payer-tab{\n    background-color: #F4F7FE;\n    height: 100vh;\n}\n\n.payer-header{\n    padding-top: 20px;\n    margin-left: 20px;\n    display: flex;\n    justify-content: space-between;\n    margin-right: 20px;\n    align-items: center;\n    padding-bottom: 20px;\n    border-bottom: 1px solid grey;\n}\n\n.payer-header>button{\n    font-size: 12px;\n}\n\n.payer-input{\n    width: 400px;\n    border-radius: 20px;\n    background-color: #FFFFFF;\n    border: none;\n    padding-left: 10px;\n    height: 40px;\n}\n\n.payer-checkbox{\n    margin-left:20px !important;\n    \n}\n\n.payer-table-head{\n    display: grid;\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n    text-align: center;\n    /* border-bottom: 1px solid #a3aed0; */\n    /* margin-top:20px; */\n    padding-bottom: 10px;\n    color: #1B2559;\n    font-weight: 600;\n    background: rgba(244, 247, 254, 0.2);\n    border-color: transparent;\n    transition-delay: 0s,0s,0s,0s;\n    transition-duration: 0.25s,0.25s,0.25s,0s;\n    transition-timing-function: linear,linear,linear,linear;\n    filter: none;\n    backdrop-filter: blur(100px);\n    /* background-color: #a3aed0; */\n    margin-top: 10px;\n    align-items: center;\n    font-size: 16px;\n    margin: 15px;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.payer-table-body{\n    display: grid;\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n    text-align: center;\n    /* border-bottom: 1px solid #a3aed0; */\n    /* margin-top:20px; */\n    padding-bottom: 10px;\n    color: gray;\n   background-color: #FFFFFF;\n    border-color: transparent;\n    transition-delay: 0s,0s,0s,0s;\n    transition-duration: 0.25s,0.25s,0.25s,0s;\n    transition-timing-function: linear,linear,linear,linear;\n    filter: none;\n\n    /* background-color: #a3aed0; */\n    margin-top: 10px;\n    align-items: center;\n    font-size: 16px;\n    margin: 15px;\n    padding: 15px 10px;\n    border-radius: 20px;\n    text-align: center;\n    font-size: 12px;\n\n}\n\n.payer-table-body:hover{\n  transform: scale(1.01);\n}\n.payer-table-head>div:nth-child(6){\n    grid-column: span 3;\n    /* text-align: center; */\n }\n\n .payer-table-body>div:nth-child(6){\n    grid-column: span 3;\n    text-align: center;\n }\n\n.payer-table{\n    margin-top: 30px;\n    height: 77vh;\n    overflow-y: scroll;\n    text-align: center;\n}\n\n.payer-table-body\n\n\n.firstreadmoreIcon{\n    display: none !important;\n}\n\n.payer-table-body:hover .firstreadmoreIcon{\n    display: block !important;\n}\n\n.payer-table-body:hover .readmoreIcon{\n    display: none !important;\n}\n\n\n\n.payer-main-header{\n     /* background-color: #FFFFFF; */\n     margin-right: 20px;\n     display: flex;\n     justify-content: space-between;\n     color: #1B2559;\n     /* padding-bottom: 20px; */\n     /* padding-top: 20px; */\n}\n\n.payer-content-div{\n    display: flex;\n    margin-top: 30px;\n}\n.payer-content-div>div:nth-child(1){\n   width: 65%;  \n   background-color: #FFFFFF;\n   margin-right: 20px;\n   height: calc(100vh - 18vh);\n   margin-left: 20px;\n   border-radius: 30px; \n}\n\n.payer-content-div>div:nth-child(2){\n    width: 35%;   \n    background-color: #FFFFFF;\n    margin-right: 20px;\n    /* height: calc(100vh - 1vh); */\n    border-radius: 30px;\n }\n\n .other-info{\n     text-align: center;\n     padding-top: 10px;\n }\n\n .other-info .head{\n     font-weight: bold;\n     font-size: 20px;\n     padding: 10px;\n     margin: 0px 50px;\n     border-bottom: 1px solid grey;\n }\n\n\n .other-info .overall-due{\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    /* background-color: #F4F7FE; */\n    margin: 10px;\n    padding: 10px;\n    border-radius: 15px;\n }\n\n .payer-invoice-head{\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    text-align: center;\n    /* border: 1px solid grey; */\n    background-color: #1F2B8F;\n    border-radius: 20px;\n    padding: 10px ;\n    color: #FFFFFF;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n }\n\n .payer-contact-head{\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    text-align: center;\n        /* border: 1px solid grey; */\n        background-color: #1F2B8F;\n        border-radius: 20px;\n        padding: 10px ;\n        color: #FFFFFF;\n        position: sticky;\n        top: 0;\n        z-index: 1;\n }\n\n\n .payer-invoice-table{\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    text-align: center;\n    /* border: 1px solid grey; */\n    margin: 10px 5px;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    padding: 10px ;\n    font-size: 12px;\n   \n }\n\n .payer-contact-table{\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    text-align: center;\n    margin: 10px 5px;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    padding: 10px ;\n }\n\n .payer-invoice{\n    margin: 10px;\n    padding: 10px;\n    background-color: #F4F7FE;\n    border-radius: 20px;\n    height: 30vh;\n    /* overflow-y: scroll; */\n    /* box-shadow: 0px 0px 5px lightblue; */\n\n }\n\n .payer-table{\n   overflow-y: scroll;\n   height:80%;\n }\n\n\n .payer-table::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .payer-table::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n  .payer-invoice>div:nth-child(1){\n     font-weight: bold;\n     color: #1B2559;\n  }\n\n  .chat-body{\n    padding: 20px;\n  }\n\n  .contact-name{\n  \n     padding: 10px;\n     border-radius: 15px;\n     display: flex;\n     justify-content: end;\n  }\n\n\n  .contact-info{\n     margin-top: 10px;\n     display: flex;\n     justify-content: space-between;\n     padding: 10px;\n     /* border: 0.2px solid lightgray; */\n     background-color: #F4F7FE;\n     border-radius: 15px;\n  }\n\n  .chat-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* margin-top: 10px; */\n    padding: 10px;\n    /* background-color: #F4F7FE; */\n    box-shadow: 0px 0px 5px lightgray;\n    border-radius: 20px 20px 0px 0px;\n  }\n\n\n  .chat-info button{\n    color: #FFFFFF;\n    background-color: #1F2B8F;\n    padding: 5px 10px;\n    border: none;\n    font-size: 13px;\n    border-radius: 5px;\n  }\n\n\n  .payer-chat{\n    width: 100%;\n    height: 70vh;\n    border: 1px solid lightgray;\n    border-radius: 20px;\n    overflow: scroll;\n    margin-top: 10px;\n    /* background-color: #F4F7FE; */\n  }\n\n  .chat-main{\n    /* height: 85%; */\n    height: calc( 100% - 140px);\n  }\n\n  .chat-bottom{\n    /* align-self: flex-end; */\n    padding: 20px 20px 20px 20px;\n     border-radius: 0px 0px 20px 20px;\n     box-shadow: 0px 0px 5px white;\n     display: flex;\n     justify-content: space-between;\n     background-color:#F4F7FE;\n     align-items: center;\n   \n  }\n\n  .input-payer{\n    width: 70%;\n    border: none;\n    background-color: #FFFFFF ;\n    border-radius: 20px;\n    /* box-shadow: 0px 0px 5px lightgray; */\n    height: 30px;\n    padding-left: 20px;\n    \n  }\n\n  .chat-main {\n    /* max-width: 600px; */\n    margin: auto;\n    overflow-y:auto ;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .message {\n    max-width: 70%;\n    margin: 10px;\n    /* padding: 15px; */\n    border-radius: 10px;\n    clear: both;\n  }\n\n  .message.left {\n    float: left;\n    /* display: block; */\n  }\n\n  .message.left>div:nth-child(1){\n    padding-bottom: 10px;\n    display: flex;\n    align-items: center;\n  }\n\n\n\n  .message.left>div:nth-child(1)>div>div{\n    font-size: 12px;\n  }\n\n  .message.left>div:nth-child(1)>div>div:nth-child(1){\n    margin-left: 5px;\n    color: cadetblue;\n    \n  }\n\n  .message.left>div:nth-child(1)>div>div:nth-child(2) span{\n    margin-left: 5px;\n    color:#4B5563;\n  }\n\n  .message.right>div:nth-child(1)>div>div{\n    font-size: 12px;\n  }\n\n  .time-zone{\n    font-size: 12px;\n    margin: 0px 5px;\n    padding: 0px 5px\n  }\n\n  .message.right>div:nth-child(1)>div>div:nth-child(1){\n    /* margin-left: 5px; */\n    color: lightslategray;\n    \n  }\n\n\n  .message.left>div:nth-child(4){\n    float: right;\n    font-size: 12px;\n    color: lightslategray;\n  }\n\n  .message.right>div:nth-child(4){\n    float: left;\n    font-size: 12px;\n    color:lightslategray;\n  }\n\n  .message.right>div:nth-child(1)>div>div:nth-child(2) span{\n    margin-left: 5px;\n    color:#FBD5D5;\n  }\n\n  .message.left>div:nth-child(3){\n    background-color: #e6e6e6;\n    padding: 10px;\n    border-radius: 10px;\n  }\n\n  .message.left>div:nth-child(2) {\n    /* float: right; */\n    font-size: 10px;\n    margin:  2px 0px 6px 0px;\n    text-align: start;\n    /* display: block; */\n\n  }\n\n  .message.right {\n    float: right;\n    /* display: block; */\n\n  }\n\n  .message.right>div:nth-child(2) {\n    /* float: right; */\n    font-size: 10px;\n    margin:  2px 0px 6px 0px;\n    text-align: end;\n    /* display: block; */\n\n  }\n\n  .message.right>div:nth-child(3){\n    background-color:turquoise;\n    color: #FFFFFF;\n    padding: 10px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: end;\n  }\n\n  .message.right>div:nth-child(1){\n    padding-bottom: 10px;\n    display: flex;\n    justify-content: end;\n    flex-direction: row-reverse;\n  }\n\n  .date-header{\n    font-weight: bold;\n    display: block;\n    display: flex;\n    justify-content: center;\n     margin-top: 10px;\n     flex-direction: column;\n  }\n\n  .date-header hr{\n    width: 100%;\n    border-bottom: 1px solid #ccc; \n\n  }\n\n  .date-header>div{\n    /* background-color: #F4F7FE; */\n    width: 100px;\n    text-align: center;\n    padding: 5px 10px;\n    border-radius: 5px ;\n    color:#1B2559;\n  }\n\n  .menu_input textarea{\n    border-radius: 20px;\n    border:  none !important;\n    background-color: #FFFFFF !important;\n    width: 100% !important;\n  }\n\n\n  .send-users{\n    display: flex;\n  }\n\n  .send-users>div{\n    padding: 0px 2px;\n  }\n\n\n  .load-more{\n    display: flex;\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  .chat-drop-down{\n    width: 150px;\n    margin: 0px 20px;\n  }\n\n\n  .payer-checkbox1 span{\n     font-size:12px !important;\n  }\n\n\n\n  .loader-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* height: 100vh; */\n    cursor: pointer;\n  }\n  \n  .loader {\n    width: 20px;\n    height: 20px;\n    border: 5px solid #f3f3f3;\n    border-top: 5px solid #3498db;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  .rotate {\n    animation-play-state: running;\n  }\n  \n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n\n  .upload-div{\n    position: absolute;\n    margin-top: -100px;\n    z-index: 99;\n    background-color: #FFFFFF;\n    border-radius: 10px;\n    box-shadow: 0px 0px 2px grey;\n    display: none;\n  }\n\n  .upload-div li{\n    padding: 5px 10px;\n  }\n\n  .upload-icon:hover .upload-div{\n    display: block;\n  }\n\n  .upload-main{\n    cursor: pointer;\n  }\n\n  .upload-main:hover .upload-div{\n    display: block;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
